export const FEATURE_SETTINGS_ADMINISTRATION_ROUTE = 'administration/fonctionnalites';
export const FEATURE_SETTINGS_ADMINISTRATION_REQUIRED_DATA = 'featureSettingsAdministrationRequired';
export const DASHBOARD_WIDGETS_ADMINISTRATION_ROUTE = 'administration/widgets';
export const DEMO_VIDEOS_ADMINISTRATION_ROUTE = 'administration/videos-demos';
export const COMPLUS_ADMINISTRATION_ROUTE = 'administration/complus';
